angular.module('impactx.opengovernmentdata').controller('SubsequentPurchaseOrderDataViewDialogCtrl', [
    '$scope',
    'dataGen',
    '$mdDialog',
    'TranslationService',
    'themeFactory',
    SubsequentPurchaseOrderDataViewDialogCtrl
]);

function SubsequentPurchaseOrderDataViewDialogCtrl($scope, dataGen, $mdDialog, TranslationService, themeFactory) {
    var self = this;

    $scope.theme = themeFactory.getTheme();
    $scope.abortLabel = TranslationService.get("abort");

    dataGen.getData($scope, {prsId: self.prsId, pohId: self.pohId, desId: self.desId}, "/subsequentpurchaseorderdata/view")
        .then(function () {}, function () {$mdDialog.cancel();});

    self.cancel = function () {
        $mdDialog.cancel();
    };

    $scope.showGroup = Array(4).fill(true);
    self.toggleGroup = function (groupIndex) {
        $scope.showGroup[groupIndex] = !$scope.showGroup[groupIndex];
    }
    self.notEmptyGroup = function (groupIndex) {
        return document.getElementById('showGroup' + groupIndex).children.length > 0;
    }
}